module.exports = __webpack_public_path__ + "img/search-header.878c7769.png";